module.exports = __webpack_public_path__ + "golden-location.png";